/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  TestRecipientWithoutFallback,
  TestRecipientWithoutFallbackInterface,
} from "../TestRecipientWithoutFallback";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "getTrustedForwarder",
    outputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "0x608060405234801561001057600080fd5b5060405161017738038061017783398101604081905261002f91610050565b600080546001600160a01b0319166001600160a01b03831617905550610080565b60006020828403121561006257600080fd5b81516001600160a01b038116811461007957600080fd5b9392505050565b60e98061008e6000396000f3fe6080604052348015600f57600080fd5b506004361060325760003560e01c8063572b6c05146037578063ce1b815f14606b575b600080fd5b605660423660046085565b6000546001600160a01b0391821691161490565b60405190151581526020015b60405180910390f35b6000546040516001600160a01b0390911681526020016062565b600060208284031215609657600080fd5b81356001600160a01b038116811460ac57600080fd5b939250505056fea264697066735822122016ad8fdc50b133c6529a4383acdce6d5fa80db6f7da984800128b8bd1ed491d564736f6c63430008070033";

type TestRecipientWithoutFallbackConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TestRecipientWithoutFallbackConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TestRecipientWithoutFallback__factory extends ContractFactory {
  constructor(...args: TestRecipientWithoutFallbackConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    forwarder: string,
    overrides?: Overrides & { from?: string }
  ): Promise<TestRecipientWithoutFallback> {
    return super.deploy(
      forwarder,
      overrides || {}
    ) as Promise<TestRecipientWithoutFallback>;
  }
  override getDeployTransaction(
    forwarder: string,
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(forwarder, overrides || {});
  }
  override attach(address: string): TestRecipientWithoutFallback {
    return super.attach(address) as TestRecipientWithoutFallback;
  }
  override connect(signer: Signer): TestRecipientWithoutFallback__factory {
    return super.connect(signer) as TestRecipientWithoutFallback__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TestRecipientWithoutFallbackInterface {
    return new utils.Interface(_abi) as TestRecipientWithoutFallbackInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TestRecipientWithoutFallback {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as TestRecipientWithoutFallback;
  }
}
